type TemplateParameterContext = {
  relatedIds: string[];
  customerId?: string;
};

export const buildTemplateParameters = (
  templateProperties: string[],
  context: TemplateParameterContext
): Record<string, string> => {
  const parameters: Record<string, string> = {};

  for (const property of templateProperties) {
    switch (property) {
      case "InvoiceId": {
        const invoiceId = context.relatedIds[0];
        if (invoiceId) {
          parameters[property] = invoiceId;
        }
        break;
      }
      case "InvoiceIds": {
        if (context.relatedIds.length > 0) {
          parameters[property] = context.relatedIds.join(",");
        }
        break;
      }
      case "CustomerId": {
        if (context.customerId) {
          parameters[property] = context.customerId;
        }
        break;
      }
      default:
        break;
    }
  }

  return parameters;
};
